import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { Accordion, Grid, Header, Icon, Image, Label, Message, Segment } from "semantic-ui-react";
import styles from "../../../../Assessment/AssessmentInfoSlideControls/LearnMoreTemplate.module.css"

const cdnRoute = process.env.REACT_APP_CDN_ROUTE + "/spiritual/";
const iconRoute = process.env.REACT_APP_CDN_ROUTE + "/icons/";

const DiscoveringPurposeLearnMore: React.FC = () => {
  const [activeAccordionIndexes] = useState([0]);

  const renderAccordionTips = () => {
    return (
      <>       
        <Grid stackable className={styles.learnMoreFullDiv} >
          <Grid.Row columns='equal' stretched className={styles.highlightsItemRow} >
            <Grid.Column stretched className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >  
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}LearnIcon.png`} className={styles.highlightsItemHeaderImgIcon} />
                  <p className={styles.highlightsItemHeaderTitle} > LEARN SOMETHING NEW </p> 
                  <Header.Subheader>
                    <p className={styles.learnMoreAccordionText} >
                        Ask the older adult if there is anything they wish they would be interested in learning. This 
                        can be something at home like knitting or woodworking or something involving social interaction 
                        like joining a pickleball club or attending regular cooking classes. Many communities have 
                        educational programs specifically for older learners.</p> 
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
            <Grid.Column stretched container className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >  
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}FamilyLove2.png`} className={`${styles.highlightsItemHeaderImgIcon} ${styles.highlightsIconEnlarge}`} />
                  <p className={styles.highlightsItemHeaderTitle} > SPEND TIME WITH FAMILY </p>
                  <Header.Subheader> 
                    <p className={styles.learnMoreAccordionText} >
                        If the older adult has family nearby, it may be beneficial to set up regular family dinners or 
                        gatherings. If distance is an issue, video conferencing apps like Zoom or Facetime can make 
                        it possible for regular face-to-face communication. </p>
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns='equal' stretched className={styles.highlightsItemRow} >
            <Grid.Column stretched className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColLeft}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >  
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}compass.svg`} className={styles.highlightsItemHeaderImgIcon} />
                  <p className={styles.highlightsItemHeaderTitle} > EXPLORE </p> 
                  <Header.Subheader>
                    <p className={styles.learnMoreAccordionText} >
                        Depending on their mobility level, getting out and experiencing new things can make a positive 
                        difference in the older adult's life. This can be anything from trying new restaurants to finding 
                        new parks in the area.</p> 
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
            <Grid.Column width={4} container className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >  
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}contactBook.svg`} className={styles.highlightsItemHeaderImgIcon} />
                  <p className={styles.highlightsItemHeaderTitle} > CHANGE OF ROUTINE </p>
                  <Header.Subheader> 
                    <p className={styles.learnMoreAccordionText} >
                        Encourage the older adult to take up a new hobby or join a social group to meet new people and 
                        do something new.</p>
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
            <Grid.Column stretched container className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColRight}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >  
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}Journaling1.png`} className={styles.highlightsItemHeaderImgEnlargeIcon} />
                  <p className={styles.highlightsItemHeaderTitle} > KEEP A JOURNAL </p>
                  <Header.Subheader> 
                    <p className={styles.learnMoreAccordionText} >
                        Writing down thoughts and ideas can be a great tool for helping the older adult find meaning in 
                        life. One idea is to write one thing they are thankful for each day and go back and read these 
                        when they are feeling down.</p>
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </>
    );
  };


  const accordions = [
    { key: 'tips',
      index: 0,
      title: { 
        icon: <Icon name='dropdown' className={styles.learnMoreAccordionLabelTitleIcon} />, 
        content: <Label className={styles.learnMoreAccordionLabelTitle} > Tips for Finding Meaning and Purpose </Label> },
      content: { 
        content: (<Message className={styles.learnMoreAccordionMessageBox} content={renderAccordionTips()}/>)
      }
    },
  ];

  
  return (
    <>
      <Segment className={styles.learnMoreBackgroundImg} style = {{ backgroundImage: `url(${cdnRoute}DiscoveringPurposeLearnMore2.jpg)`, }}>
        <div className={styles.learnMoreModalContent}>

          <div className={styles.learnMoreAccordionFullDivGrid} >
            <div className={styles.learnMoreAccordionFullDiv} >
              <Accordion panels={accordions} className={styles.learnMoreModalAccordionGroup} defaultActiveIndex={activeAccordionIndexes} exclusive={false} />
            </div> 
          </div>  

        </div>
      </Segment>      
    </>
  );  
};

export default observer(DiscoveringPurposeLearnMore);
